module.exports = __webpack_public_path__ + "img/icon_data.20238916.svg";